// "Stop lesson reminders" page — client side of functions/lessonReminders.js.
//
// One public callable, keyed by the random token in the email's stop link and
// deliberately NOT App-Check-gated (functions/index.js → lessonReminderOptOut
// says why: stopping mail must work from any browser). Nothing here reads
// Firestore directly: the token and opt-out collections are Functions-only.
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// action: 'status' (just look) | 'stop' | 'resume'.
// Resolves { ok, email (masked), stopped } or { ok: false, reason }.
export async function reminderOptOut(token, action) {
	const callable = httpsCallable(functions, 'lessonReminderOptOut');
	const { data } = await callable({ token, action });
	return data;
}
